import { DefaultState, DropdownItem } from 'store/types';

export const READ_OCCUPANCY_INSIGHTS_FILTERS_REQUEST = 'READ_OCCUPANCY_INSIGHTS_FILTERS_REQUEST';
export const READ_OCCUPANCY_INSIGHTS_FILTERS_SUCCESS = 'READ_OCCUPANCY_INSIGHTS_FILTERS_SUCCESS';
export const READ_OCCUPANCY_INSIGHTS_FILTERS_FAILURE = 'READ_OCCUPANCY_INSIGHTS_FILTERS_FAILURE';

export interface OccupancyInsightsFilterData {
  dates: DropdownItem[];
  miles: number;
}

export type OccupancyInsightsFiltersState = DefaultState & {
  contents?: OccupancyInsightsFilterData;
};

interface ReadOccupancyInsightsFiltersRequest {
  type: typeof READ_OCCUPANCY_INSIGHTS_FILTERS_REQUEST;
}

interface ReadOccupancyInsightsFiltersSuccess {
  type: typeof READ_OCCUPANCY_INSIGHTS_FILTERS_SUCCESS;
  contents: OccupancyInsightsFilterData;
}

interface ReadOccupancyInsightsFiltersFailure {
  type: typeof READ_OCCUPANCY_INSIGHTS_FILTERS_FAILURE;
}

export type OccupancyInsightsFiltersActionTypes =
  | ReadOccupancyInsightsFiltersRequest
  | ReadOccupancyInsightsFiltersSuccess
  | ReadOccupancyInsightsFiltersFailure;
